import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { id: 'Artboard-32' }),
  React.createElement('path', { id: 'Artboard-32-2', 'data-name': 'Artboard-32' }),
  React.createElement('path', { d: 'M11.84 9.71H28v1.3H11.84zM11.84 13.98H28v1.3H11.84zM4 18.25h24v1.3H4zM4 22.52h14.01v1.3H4z' }),
  React.createElement('path', { d: 'M6.44 9.53h1l2.45 5.66H8.71l-.55-1.29H5.75l-.55 1.29H4zm1.29 3.36L7 11l-.78 1.85z' })
));